import type { Article } from "./types";
import { articles as en } from "./en";
import { articles as es } from "./es";
import { articles as fr } from "./fr";
import { articles as pl } from "./pl";

const map: Record<string, Article[]> = { en, es, fr, pl };

export function getArticles(lang: string): Article[] {
  const key = lang.split("-")[0];
  return map[key] || en;
}

export function getArticle(lang: string, slug: string): Article | undefined {
  return getArticles(lang).find((a) => a.slug === slug);
}

export function getArticleSlugs(): string[] {
  return en.map((a) => a.slug);
}